<template>
  <div id="ModalUndetected" v-if="taskDetailData">
    <!-- <a-drawer
      wrapClassName="wrapModalUndetected"
      width="1000"
      :closable="false"
      :visible="visible"
      @close="onClose"
    > -->
      <div class="title"><span @click="onClose"><img src="@/assets/back.png" />返回</span></div>
      <div>
        <ul class="ModalHeader">
          <li style="width: 30%;">
            <span>任务名称</span>
            <b>{{taskDetailData.TASK_NAME}}</b>
          </li>
          <li style="width: 17%;">
            <span>未测总数</span>
            <b v-if="newData">{{newData.length}}</b>
          </li>
          <li style="width: 15%;">
            <span>进度</span>
            <a-progress :percent="parseFloat(parseFloat(taskDetailData.PROGRESS).toFixed(2))" :strokeWidth="6" />
          </li>
          <li>
            <span style="color: transparent;">点击打开二级抽屉</span>
            <a @click="showChildrenDrawer" style="text-decoration: underline;color: #317ED0;margin-left: 24px;">进度有误？点击尝试修正进度</a>
          </li>
        </ul>
        <p class="end" v-if="days === '-0'">任务将在今天结束</p>
        <p class="end" v-if="days > 0">距任务结束还有{{days}}天</p>
      </div>
      <div class="ModalBody" v-if="newData">
        <div class="modalTop">
          <div class="bodyHeader">
            <a-select allowClear style="width: 120px" @change="gradeChange" placeholder="筛选年级">
              <a-select-option v-for="province in gradeArr" :key="province.YEAR">{{province.GRADE}}</a-select-option>
            </a-select>
            <a-select allowClear style="width: 120px" @change="classChange" placeholder="筛选班级">
              <a-select-option v-for="province in classArr" :key="province">{{province}}</a-select-option>
            </a-select>
            <a-input style="width: 180px;" placeholder="搜索姓名/身份证/学籍号" v-model="inputValue" />
            <a-config-provider :autoInsertSpaceInButton="false">
              <a-button @click="searchHandle">查询</a-button>
            </a-config-provider>
            <span style="color: #8C8C8C;">{{newDataFilter.length}}条搜索结果</span>
          </div>
          <div class="exportDiv">
            <a-config-provider :autoInsertSpaceInButton="false">
              <a-button @click="exportUndetecetd">导出未测名单</a-button>
            </a-config-provider>
          </div>
        </div>
        <a-table :columns="columns" :dataSource="newDataFilter" :rowKey="row => row.UID" :pagination=" newDataFilter.length > 7 ? pagination : false">
          <template slot="STUDENT_ID_CARD" slot-scope="text">
            <a-popover>
              <template slot="content">
                <span>{{text ? text : '暂无'}}</span>
              </template>
              <a-icon type="eye" theme="filled" />
            </a-popover>
          </template>
          <template slot="STUDENT_ID_SOCIAL" slot-scope="text">
            <a-popover>
              <template slot="content">
                <span>{{text ? text : '暂无'}}</span>
              </template>
              <a-icon type="eye" theme="filled" />
            </a-popover>
          </template>
        </a-table>
      </div>
      <a-drawer
        wrapClassName="wrapchildrenDrawer"
        width="800"
        :closable="false"
        :visible="childrenDrawer"
        @close="onChildrenDrawerClose"
      >
        <div class="title"><span @click="onChildrenDrawerClose"><img src="@/assets/back.png" />返回</span></div>
        <div class="childrenDrawerContent">
          <h2>修正进度</h2>
          <ol>
            <li>
              <div><img src="@/assets/first.png" alt=""></div>
              <h3>第一步，确认名单中的学生是否为本校学生</h3>
              <span>点击【导出名单】，建议将该名单交由班主任核对，核查出非本校学生</span>
              <a-button type="primary" @click="importhandle" style="margin-top: 22px; color: #FFFFFF;">导出名单</a-button>
            </li>
            <li>
              <div><img src="@/assets/second.png" alt=""></div>
              <h3>第二步，完成核查后，点击下方列表以修正进度</h3>
              <span>本校学生请点击【是本校学生】，非本校学生请点击【否】</span>
            </li>
          </ol>
          <div class="info">
            <a-icon type="info-circle" />
            请谨慎选择
          </div>
        </div>
        <a-table :columns="columns_item" :dataSource="taskotherstudent" :rowKey="row => row.UID" >
          <template slot="SEX" slot-scope="text">
            <span>{{text === 1 ? '男' : (text === 2 ? '女' : '未知')}}</span>
          </template>
          <template slot="STUDENT_ID_CARD" slot-scope="text">
            <span>{{text ? text : '暂无'}}</span>
          </template>
          <template slot="operation" slot-scope="text, record">
            <a-button class="action" style="margin-right: 16px;" @click="updateHandle(record)">是本校学生</a-button>
            <a-button class="action" @click="deleteHandle(record.UID)">否</a-button>
          </template>
        </a-table>
      </a-drawer>
    <!-- </a-drawer> -->
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import GradeFormat from '@/util/gradeFormat'
  import GradeNum from '@/util/gradeNum'
  import XLSX from 'xlsx'
  export default {
    name: 'ModalUndetected',
    props: [
      'taskDetailData'
    ],
    data () {
      return {
        newData: [],
        newDataFilter: [],
        gradeArr: [],
        classArr: [],
        inputValue: null,
        grade: null,
        class: null,
        days: null,
        childrenDrawer: false,
        pagination: {
          pageSize: 7, // 默认每页显示数量
          showQuickJumper: true,
          // showSizeChanger: true
        },
        columns: [
          {
            title: '学生姓名',
            dataIndex: 'REAL_NAME',
          },
          {
            title: '性别',
            dataIndex: 'SEX_V',
          },
          {
            title: '年级',
            dataIndex: 'GRADE',
          },
          {
            title: '班级',
            dataIndex: 'CLASS',
          },
          {
            title: '身份证',
            dataIndex: 'STUDENT_ID_CARD',
            scopedSlots: { customRender: 'STUDENT_ID_CARD' },
          },
          {
            title: '学籍号',
            dataIndex: 'STUDENT_ID_SOCIAL',
            scopedSlots: { customRender: 'STUDENT_ID_SOCIAL' },
          }
        ],
        columns_item: [
          {
            title: '学生姓名',
            dataIndex: 'REAL_NAME',
            width: '20%'
          },
          {
            title: '性别',
            dataIndex: 'SEX',
            scopedSlots: { customRender: 'SEX' },
            width: '13%'
          },
          {
            title: '身份证',
            dataIndex: 'STUDENT_ID_CARD',
            scopedSlots: { customRender: 'STUDENT_ID_CARD' },
            width: '30%'
          },
          {
            title: '操作',
            dataIndex: 'operation',
            key: 'operation',
            scopedSlots: { customRender: 'operation' }
          }
        ]
      }
    },
    computed: {
      ...mapState([
        'schoolInfos',
        'unfinishedStudents',
        'gameGroup',
        'minGrade',
        'maxGrade',
        'taskotherstudent',
        'editBackInfos',
        'userInfo'
      ])
    },
    methods: {
      ...mapActions([
        'getTaskotherstudent',
        'getTaskupdatestatus',
        'editStuInfo',
        'getUnfinishedStudents'
      ]),
      async updateHandle (record) { // 是本校学生
        console.log(record)
        await this.editStuInfo({uid: record.UID, result: {
          CLASS_ID: record.CLASS_ID,
          GRADE_ID: record.GRADE_ID
        }})
        console.log(this.editBackInfos)
        if (this.editBackInfos) {
          await this.getTaskotherstudent(this.taskDetailData.DQ_ID)
          await this.getUnfinishedStudents({item: {DQ_ID: this.taskDetailData.DQ_ID}})
          this.$message.success('学生已导入学校，请安排学生完成测评')
        }
      },
      async deleteHandle (uid) { // 否
        console.log(uid)
        let status = await this.getTaskupdatestatus({uid: uid, qid: this.taskDetailData.DQ_ID})
        if (status) {
          await this.getTaskotherstudent(this.taskDetailData.DQ_ID)
          this.$message.success('非本校学生已删除，进度已同步')
        }
      },
      onClose () {
        this.$emit('close')
      },
      async showChildrenDrawer () {
        this.childrenDrawer = true;
        await this.getTaskotherstudent(this.taskDetailData.DQ_ID)
        console.log(this.taskotherstudent)
      },
      onChildrenDrawerClose() {
        this.childrenDrawer = false;
      },
      gradeChange (value) {
        let newClass = []
        this.classArr = []
        this.grade = GradeNum(value, this.userInfo.SCHOOL_TYPE)
        if (value) { // 选中年级
          if (this.userInfo.role_id === 3 && this.userInfo.class_list && this.userInfo.class_list.length) {
            let gradeClass = []
            this.userInfo.class_list.map(list => {
              gradeClass.push(list.grade_id + '' + list.class_id)
            })
            this.unfinishedStudents.map(info => {
              if (parseInt(value) === info.GRADE_ID && gradeClass.includes(info.GRADE_ID + '' + info.CLASS_ID)) {
                if (!newClass.includes(info.CLASS_ID)) {
                  newClass.push(info.CLASS_ID)
                }
              }
            })
          } else {
            this.unfinishedStudents.map(info => {
              if (parseInt(value) === info.GRADE_ID) {
                if (!newClass.includes(info.CLASS_ID)) {
                  newClass.push(info.CLASS_ID)
                }
              }
            })
          }
        } else { // 取消选中年级
          if (this.userInfo.role_id === 3 && this.userInfo.class_list && this.userInfo.class_list.length) {
            let gradeClass = []
            this.userInfo.class_list.map(list => {
              gradeClass.push(list.grade_id + '' + list.class_id)
            })
            this.gradeArr.map(item => { // 任务包含的所有班级、班级
              this.unfinishedStudents.map(info => {
                if (parseInt(item.YEAR) === info.GRADE_ID && gradeClass.includes(info.GRADE_ID + '' + info.CLASS_ID)) {
                  if (!newClass.includes(info.CLASS_ID)) {
                    newClass.push(info.CLASS_ID)
                  }
                }
              })
            })
          } else {
            this.gradeArr.map(item => { // 任务包含的所有班级、班级
              this.unfinishedStudents.map(info => {
                if (parseInt(item.YEAR) === info.GRADE_ID) {
                  if (!newClass.includes(info.CLASS_ID)) {
                    newClass.push(info.CLASS_ID)
                  }
                }
              })
            })
          }
        }
        newClass.sort((a, b) => {
          return a - b
        })
        newClass.map(info => {
          this.classArr.push(info + '班')
        })
      },
      classChange (value) {
        if (value) {
          this.class = value.split('班')[0]
        } else {
          this.class = value
        }
      },
      searchHandle () { // 筛选框
        this.newDataFilter = this.newData.filter((item) => !this.grade ? true : item.GRADE === this.grade).filter((item) => !this.class ? true : item.CLASS === this.class).filter((item) => !this.inputValue ? true : ((item.REAL_NAME.indexOf(this.inputValue) !== -1) || (item.STUDENT_ID_CARD ? item.STUDENT_ID_CARD.indexOf(this.inputValue) !== -1 : '')) || (item.STUDENT_ID_SOCIAL ? item.STUDENT_ID_SOCIAL.indexOf(this.inputValue) !== -1 : ''))
      },
      importhandle () { // 导出修正进度名单
        if (this.taskotherstudent && this.taskotherstudent.length) {
          let finishData = []
          this.taskotherstudent.map(item => {
            finishData.push({'姓名': item.REAL_NAME, '性别': item.SEX === 1 ? '男' : (item.SEX === 2 ? '女' : '未知'), '身份证号': item.STUDENT_ID_CARD})
          })
          let wb = {
            SheetNames: [],
            Sheets: { sheet1: 'ww' }
          }
          let ws = XLSX.utils.json_to_sheet(finishData)
          XLSX.utils.book_append_sheet(wb, ws, '修正进度名单')
          XLSX.writeFile(wb, `修正进度名单.xlsx`, { compression: true })
        } else {
          this.$message.success('没有可以导出的学生')
        }
      },
      exportUndetecetd () { // 导出全校未测名单
        if (this.newDataFilter && this.newDataFilter.length) {
          let finishData = []
          this.newDataFilter.map(item => {
            finishData.push({'姓名': item.REAL_NAME, '性别': item.SEX_V, '年级': item.GRADE, '班级': item.CLASS + '班', '身份证号': item.STUDENT_ID_CARD, '学籍号': item.STUDENT_ID_SOCIAL})
          })
          let wb = {
            SheetNames: [],
            Sheets: { sheet1: 'ww' }
          }
          let ws = XLSX.utils.json_to_sheet(finishData)
          XLSX.utils.book_append_sheet(wb, ws, '未测学生名单')
          XLSX.writeFile(wb, `未测学生名单.xlsx`, { compression: true })
        } else {
          this.$message.success('没有可以导出的学生')
        }
      },
      closeHandle () {
        this.$emit('close')
      },
      publicFun () {
        let newData = []
        let newClass = []
        this.classArr = []
        let gradeList = []
        this.gradeArr = []
        let grade = JSON.parse(sessionStorage.getItem('gradeMaxMin'))
        let startDate = new Date().getTime()
        let endDate = new Date(this.taskDetailData.TASK_END_DATE).getTime()
        let days= endDate - startDate
        this.days = (days/(24*60*60*1000)).toFixed(0) // 距离任务结束天数
        console.log(this.taskDetailData)
        this.taskDetailData.GRADE_LIST.split(',').map((item) => { // 任务包含的所有班级、班级
          if (!gradeList.includes(parseInt(item))) {
            if (item <= grade[1] && item >= grade[0]) {
              gradeList.push(parseInt(item))
            }
          }
        })
        gradeList.sort((a, b) => {
          return a - b
        })
        if (this.userInfo.role_id === 3) {
          if (this.userInfo.class_list && this.userInfo.class_list.length) {
            this.userInfo.class_list.map(item => {
              this.gradeArr.push({GRADE: GradeNum(item.grade_id, this.userInfo.SCHOOL_TYPE), YEAR: item.grade_id})
            })
          }
        } else {
          gradeList.map((item) => {
            this.gradeArr.push({GRADE: GradeNum(item, this.userInfo.SCHOOL_TYPE), YEAR: item})
          })
        }
        if (this.taskDetailData.GROUP_TYPE === 1) { // 量表
          newData = []
          let unfinishedStudentsGrade = []
          if (this.unfinishedStudents) {
            if (this.userInfo.role_id === 3 && this.userInfo.class_list && this.userInfo.class_list.length) {
              let gradeClass = []
              this.userInfo.class_list.map(list => {
                gradeClass.push(list.grade_id + '' + list.class_id)
              })
              unfinishedStudentsGrade = this.unfinishedStudents.filter((item) => gradeClass.includes(item.GRADE_ID + '' + item.CLASS_ID))
            } else {
              unfinishedStudentsGrade = this.unfinishedStudents.filter((item) => item)
            }
            this.gradeArr.map(item => {
              unfinishedStudentsGrade.map(info => {
                if (parseInt(item.YEAR) === info.GRADE_ID) {
                  if (!newClass.includes(info.CLASS_ID)) {
                    newClass.push(info.CLASS_ID)
                  }
                }
              })
            })
            newClass.sort((a, b) => {
              return a - b
            })
            newClass.map(info => {
              this.classArr.push(info + '班')
            })
            // parseInt(item.GRADE) <= this.minGrade && parseInt(item.GRADE) >= this.maxGrade
            unfinishedStudentsGrade.map((unFinished) => {
              newData.push({
                UID: unFinished.UID,
                REAL_NAME: unFinished.REAL_NAME,
                STUDENT_ID_CARD: unFinished.STUDENT_ID_CARD,
                STUDENT_ID_SOCIAL: unFinished.STUDENT_ID_SOCIAL,
                CLASS: unFinished.CLASS_ID + '',
                GRADE: GradeNum(unFinished.GRADE_ID, this.userInfo.SCHOOL_TYPE),
                SEX_V: (unFinished.SEX === 2 ? '女' : (unFinished.SEX === 1 ? '男' : '未知'))
              })
            })
          }
          // newData = unfinishedStudentsGrade
        } else if (this.taskDetailData.GROUP_TYPE === 2) { // 游戏
          newData = []
          let unFinish = []
          if (this.gameGroup && this.gameGroup.length) {
            this.gameGroup.map((game) => {
              if (game.planid === this.taskDetailData.DQ_ID) {
                if (!game.fini.length) {
                  unFinish = game.dis
                } else {
                  console.log('有人已测')
                  game.dis.map((item) => {
                    if (!game.fini.includes(item)) {
                      unFinish.push(item)
                    }
                  })
                }
              } else {
                console.log('what===????')
              }
            })
          }
          unFinish.map((list) => {
            this.schoolInfos.map((info) => {
              if (parseInt(list) === info.UID) {
                newData.push({
                  CLASS: info.CLASS_ID + '',
                  GRADE: GradeFormat(info.ENTRYYEAR),
                  ENTRYYEAR: parseInt(info.ENTRYYEAR),
                  REAL_NAME: info.REAL_NAME,
                  SEX_V: (info.SEX === 2 ? '女' : (info.SEX === 1 ? '男' : '未知')),
                  STUDENT_ID_CARD: info.STUDENT_ID_CARD,
                  STUDENT_ID_SOCIAL: info.STUDENT_ID_SOCIAL,
                  UID: info.UID
                })
              }
            })
          })
        }
        this.newData = newData
        newData.sort((a, b) => {
          return a.CLASS - b.CLASS
        })
        this.newDataFilter = newData
        this.newDataFilter.sort((a, b) => {
          return b.ENTRYYEAR - a.ENTRYYEAR
        })
      }
    },
    watch: {
      gameGroup () {
        this.publicFun()
      },
      unfinishedStudents () {
        this.publicFun()
      }
    },
    mounted () {
      
    }
  }
</script>

<style>
  #ModalUndetected  {
  }
  /* .wrapModalUndetected div:first-child {
    border-bottom: 1px solid #EBEBEB;
    padding: 32px 32px 14px;
    box-sizing: border-box;
  } */
  .wrapModalUndetected .title, .wrapchildrenDrawer .title {
    padding: 32px 32px 16px;
    box-sizing: border-box;
    display: inline-block;
  }
  .wrapModalUndetected .title span, .wrapchildrenDrawer .title span {
    cursor: pointer;
    padding: 8px;
    display: flex;
    align-items: center;
  }
  .wrapModalUndetected .title span:hover, .wrapchildrenDrawer .title span:hover {
    background-color: #F5F5F5;
  }
  .wrapModalUndetected .title img, .wrapchildrenDrawer .title img {
    width: 16px;
    height: auto;
    margin-right: 8px;
  }
  .wrapModalUndetected .ModalHeader {
    display: flex;
    padding-left: 40px;
    padding-top: 24px;
    margin-bottom: 0px;
    border-top: 1px solid #E8E8E8;
  }
  .wrapModalUndetected .ModalHeader li {
    display: flex;
    flex-direction: column;
    width: 23%;
  }
  .wrapModalUndetected .ModalHeader li .ant-progress {
    width: 95%;
  }
  .wrapModalUndetected .ModalHeader li>span {
    color: #8C8C8C;
    font-size: 14px;
    margin-bottom: 16px;
  }
  .wrapModalUndetected .ModalHeader li b {
    font-weight: normal;
    color: #262626;
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-right: 20px;
  }
  .wrapModalUndetected .ModalHeader li:nth-child(3) b {
    font-size: 24px;
  }
  .wrapModalUndetected .ModalBody {
    border-top: 1px solid #E8E8E8;
    margin-top: 24px;
  }
  .wrapModalUndetected div > .end {
    color: #F58622;
    font-size: 12px;
    margin-bottom: 0px!important;
    padding-bottom: 0px!important;
    /* transform: translateY(-80%); */
    padding-left: 40px;
  }
  .wrapModalUndetected .modalTop {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .wrapModalUndetected .modalTop .exportDiv .ant-btn {
    margin-right: 32px;
  }
  .wrapModalUndetected .bodyHeader {
    padding: 24px 32px 16px;
    box-sizing: border-box;
  }
  .wrapModalUndetected .ant-select {
    margin-right: 16px;
  }
  .wrapModalUndetected .bodyHeader .ant-btn {
    margin-left: 16px;
    margin-right: 16px;
    background: #51BF94;
    color: #FFFFFF;
  }
  .wrapModalUndetected .ant-pagination, .wrapchildrenDrawer .ant-pagination {
    margin-right: 40px;
    margin-top: 20px;
  }
  .wrapModalUndetected .ant-table-thead > tr > th, .wrapModalUndetected .ant-table-tbody > tr > td, .wrapchildrenDrawer .ant-table-thead > tr > th, .wrapchildrenDrawer .ant-table-tbody > tr > td {
    padding-left: 40px;
    color: #262626;
    font-size: 14px;
  }
  .wrapchildrenDrawer .ant-table-tbody > tr > td {
    padding: 15px 0px 15px 40px;
  }
  .wrapModalUndetected .ant-table-tbody > tr > td:nth-child(5), .wrapModalUndetected .ant-table-tbody > tr > td:nth-child(6) {
    /* text-align: center; */
    padding-left: 44px;
  }
  .wrapModalUndetected .ant-table-thead > tr > th, .wrapchildrenDrawer .ant-table-thead > tr > th {
    font-size: 12px;
    color: #8C8C8C;
  }
  .ant-btn:hover, .ant-btn:focus {
    color: #51BF94;
    border-color: #51BF94;
  }
  .ant-table-placeholder {
    border-bottom: 0px;
  }
  .ant-steps-item-process > .ant-steps-item-tail::after {
    width: 2px;
    background-color: #0089FF;
  }
  .wrapchildrenDrawer .childrenDrawerContent {
    padding: 24px 40px 0px;
    box-sizing: border-box;
    border-top: 1px solid #E8E8E8;
    position: relative;
  }
  .wrapchildrenDrawer .childrenDrawerContent h2 {
    margin-bottom: 24px;
    font-size: 24px;
    color: #171A1D;
    font-weight: bold;
  }
  .wrapchildrenDrawer .childrenDrawerContent ol {
    padding-left: 16px;
  }
  .wrapchildrenDrawer .childrenDrawerContent ol li {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding-bottom: 22px;
    padding-left: 30px;
    position: relative;
  }
  .wrapchildrenDrawer .childrenDrawerContent ol li div:first-child {
    background-color: #FFFFFF;
    position: absolute;
    left: -17px;
  }
  .wrapchildrenDrawer .childrenDrawerContent ol li img {
    width: 32px;
    height: auto;
  }
  .wrapchildrenDrawer .childrenDrawerContent ol li:first-child {
    border-left: 2px solid #0089FF;
  }
  .wrapchildrenDrawer .childrenDrawerContent ol li h3 {
    font-size: 18px;
    color: #171A1D;
    font-weight: normal;
    margin-bottom: 12px;
  }
  .wrapchildrenDrawer .childrenDrawerContent ol li span {
    font-size: 14px;
    color: rgba(23, 26, 29, 0.6);
  }
  .wrapchildrenDrawer ol li .ant-btn span {
    color: #FFFFFF!important;
    font-size: 16px;
    padding: 0px 30px;
  }
  .wrapchildrenDrawer .info {
    position: absolute;
    z-index: 999;
    right: 125px;
    top: 330px;
    font-size: 14px;
    color: #FF9200;
  }
</style>